import React from 'react';
import './loader.css';

export function BlockingLoader(props){
    return (
        <div className="d5b73a-loading" id="js-loader">
            <div className="d5b73a-loader"></div>
        </div>
    )
}

export function NonBlockingLoader(props){
    return <div style={{position: 'fixed'}} className="d5b73a-loader"></div>
}